import React, { FC } from 'react';
import SayKitWeb from '@whitesharx/starfall-frontend-saykit-web';
import DeeplinkModalFirst from './DeeplinkModalFirst';
import DeeplinkModalSecond from './DeeplinkModalSecond';
import DeeplinkModalThird from './DeeplinkModalThird';
import { contentBlockerStyles } from '~/src/screens/Guest/styles.css';
import { Analytics } from '~/src/services/analytics';
import { TAP_EVENTS } from '~/src/services/analytics/contants';

type Props = {
  onRequestClose: () => void;
  Analytics: Analytics;
};

const DeeplinkModal: FC<Props> = ({ Analytics, onRequestClose }) => {
  const handleClick = () => {
    Analytics.sendEvent(TAP_EVENTS.deeplink);
  };

  return (
    <>
      <div className={contentBlockerStyles} style={{ zIndex: 8 }} />

      {SayKitWeb.featureFlags.deeplink_text === 1 && (
        <DeeplinkModalFirst onRequestClose={onRequestClose} onClick={handleClick} />
      )}
      {SayKitWeb.featureFlags.deeplink_text === 2 && (
        <DeeplinkModalSecond onRequestClose={onRequestClose} onClick={handleClick} />
      )}
      {SayKitWeb.featureFlags.deeplink_text === 3 && (
        <DeeplinkModalThird onRequestClose={onRequestClose} onClick={handleClick} />
      )}
    </>
  );
};

export default DeeplinkModal;
